import { useSignal } from "@preact/signals-react";

import { SuitcaseIcon, UsersIcon2, NotesIcon } from "components/Icons/linear";
import MainMenu from "componentsv2/widgets/MainMenu";
import Layout from "components/Layout/ViewLayout";

const styleIcon =
  "relative md:size-[60px] size-11 text-[#ffcc00FF] mx-auto my-3  group-hover:transition-all group-duration-300 ease-in-out group-hover:scale-110";

const view = [
  {
    name: "crm_opportunities_title",
    desc: "crm_opportunities_desc",
    link: "crm_sales/opportunity",
    Icon: <SuitcaseIcon className={styleIcon} />,
    bg: "#FDFFD6",
  },
  {
    name: "crm_prospects_title",
    desc: "crm_prospects_desc",
    link: "crm_sales/prospect",
    Icon: <UsersIcon2 className={styleIcon} />,
    bg: "#CFEEFF",
  },
  {
    name: "crm_activities_title",
    desc: "crm_activities_desc",
    link: "crm_sales/activity",
    Icon: <NotesIcon className={styleIcon} />,
    bg: "#F7E2FE",
  },
];

function ScreenCRM() {
  const currentView = useSignal(null);

  return (
    <Layout currentView={currentView} title="crm_name">
      <MainMenu views={view} desc="crm.title_main" />
    </Layout>
  );
}

export default ScreenCRM;
